// extracted by css-extract-rspack-plugin
export default {"Overlay":"soN1a","z1":"Nsvne","z2":"RYWvA","z3":"ODutq"};